import styled from 'styled-components';
import { CSSVars } from '../../styles/styles.config';

export const StyledDiv = styled.div`
	position: relative;
	margin: 0 auto;
	max-width: 1420px;
	padding: 100px 20px;

	.main-content-wrapper {
		margin-top: 30px;
		display: flex;
		gap: 50px;
		max-width: 1220px;
		margin: 0 auto;

		@media (max-width: 655px) {
			flex-direction: column;
		}

		.filter-container {
			min-width: 220px;
			display: flex;
			flex-direction: column;
			gap: 15px;
			position: sticky;
			top: 30px;
			height: fit-content;

			@media (max-width: 655px) {
				position: static;
			}

			.categories {
				padding-left: 10px;
				display: flex;
				flex-direction: column;

				.cat-title {
					font-weight: 500;
					font-size: ${CSSVars.fontSizeSM};
					color: #000000;
					margin: 5px 0;
				}

				.divider {
					border-top: 1px solid rgba(0, 0, 0, 0.15);
					margin: 5px 0;
				}

				.cat {
					cursor: pointer;
					display: flex;
					align-items: center;
					color: ${CSSVars.black};
					gap: 10px;
					border: none;
					background: transparent;
					font-weight: 300;
					font-size: ${CSSVars.fontSizeSM};
					line-height: 17px;
					transition: 0.2s;
					padding: 10px;
					border-radius: 5px;

					.icon {
						font-size: 18px;
					}

					&:hover {
						color: ${CSSVars.blue};
					}

					&.active{
						color: ${CSSVars.blue};
						background-color: ${CSSVars.blue50};
					}
				}
			}
		}

		.widget-catalog-home {
			display: flex;
			flex-direction: column;
			gap: 100px;

			h3 {
				font-size: 22px;
				font-weight: 600;
				display: flex;
				align-items: center;
				gap: 5px;
				margin: 0 0 30px;
				color: ${CSSVars.gray900};

				svg {
					color: #747b95;
				}
			}
		}

		.apps-container {
			gap: 20px;
			display: flex;
			align-items: flex-start;
			flex-wrap: wrap;

			&:has(.no-items) {
				align-items: center;
				width: 100%;
			}

			.no-items {
				max-width: 100%;
				width: 520px;
				display: flex;
				flex-direction: column;
				align-items: center;
				margin: 0 auto;

				p {
					font-size: 16px;
					padding-left: 20px;
				}

				img {
					max-width: 200px;
				}

				&.embd-promo {
					background-color: ${CSSVars.white};
					border: 1px solid ${CSSVars.gray200};
					border-radius: 5px;
					overflow: hidden;
					display: flex;
					flex-direction: column;
					text-align: center;
					align-items: center;
					justify-content: center;

					.promo-banner {
						display: flex;
						align-items: center;
						justify-content: center;
						position: relative;
						padding: 40px 40px 0;

						.promo-icon {
							position: relative;
							z-index: 1;
						}
					}

					.promo-content {
						padding: 30px;
						display: flex;
						flex-direction: column;
						gap: 15px;

						h2 {
							font-size: 24px;
							font-weight: 600;
							margin: 0;
							color: #1e2a3b;
							line-height: 1.3;

							@media (max-width: 655px) {
								font-size: 20px;
							}
						}

						h3 {
							font-size: 20px;
							font-weight: 700;
							margin: 0;
							color: #667eea;
							line-height: 1.4;

							@media (max-width: 655px) {
								font-size: 18px;
							}
						}

						p {
							font-size: 15px;
							line-height: 1.6;
							color: #5a6c7d;
							margin: 0;
							padding: 0;

							@media (max-width: 655px) {
								font-size: 14px;
							}
						}

						.promo-features {
							display: flex;
							justify-content: center;
							align-items: center;
							gap: 10px;
							flex-wrap: wrap;
							margin: 5px 0;

							span {
								background: #f0f4ff;
								padding: 8px 16px;
								border-radius: 20px;
								font-size: 13px;
								font-weight: 500;
								color: #667eea;
								border: 1px solid #e0e8ff;
								transition: all 0.2s ease;

								&:hover {
									background: #e0e8ff;
									transform: translateY(-1px);
								}
							}
						}

						button {
							margin-top: 10px;
							transition: all 0.2s ease;
							background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
							border: none;
							font-weight: 600;

							&:hover {
								transform: translateY(-2px);
								box-shadow: 0 10px 25px rgba(102, 126, 234, 0.3);
							}
						}
					}
				}
			}

			.app {
				background-color: ${CSSVars.white};
				border: 1px solid ${CSSVars.gray100};
				border-radius: 5px;
				cursor: pointer;
				position: relative;
				display: flex;
				flex-direction: column;
				flex: 1;
				transition: 0.2s;
				min-width: 280px;
				max-width: 330px;

				@media (max-width: 655px) {
					max-width: 100%;
				}

				&:hover {
					border: 1px solid ${CSSVars.gray200};
					box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
				}

				.new-ribbon {
					position: absolute;
					top: 10px;
					right: 0px;
					background: linear-gradient(90deg, ${CSSVars.pink} 0%, ${CSSVars.blue} 100%);
					color: white;
					padding: 6px 25px;
					font-size: 12px;
					font-weight: 700;
					letter-spacing: 0.5px;
					z-index: 2;
					box-shadow: 0 2px 8px rgba(102, 126, 234, 0.4);
					border-radius: 2px 0 0 2px;
				}

				img {
					width: 100%;
					height: 170px;
					object-fit: cover;
					border-radius: 5px 5px 0 0;
				}

				.details {
					display: flex;
					flex-direction: column;
					gap: 5px;
					color: #1e2a3b;
					padding: 20px;
					min-height: 120px;

					h3 {
						font-weight: 500;
						font-size: 18px;
						line-height: 20px;
						margin: 0;

						overflow: hidden;
						text-overflow: ellipsis;
						display: -webkit-box;
						-webkit-line-clamp: 2;
						line-clamp: 2;
						-webkit-box-orient: vertical;
					}

					p {
						margin: 0;
						font-weight: 300;
						font-size: ${CSSVars.fontSizeSM};
						line-height: 20px;

						overflow: hidden;
						text-overflow: ellipsis;
						display: -webkit-box;
						-webkit-line-clamp: 3;
						line-clamp: 3;
						-webkit-box-orient: vertical;
					}
				}
			}
		}
	}
`;
